import React, { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MyModal from '../../../../UI/modal/MyModal';
import DeleteBillItemForm from './DeleteBillItemForm';

const DeleteBillItemButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            color='red'
            onClick={e => setOpen(true)}
        >
            {
                <DeleteForeverIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Видалення позиції'}
            disableClickOutside={true}
            content={
                <DeleteBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default DeleteBillItemButton